import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { useFeatureFlags, useMerchantModel } from "client/hooks";
import { CountryList } from "client/lib/apt-merchant";
import { CountryToCountryCodeMap } from "client/lib/apt-merchant/src/fields/companyInformation/RegisteredCountryField";

export const RegisteredCountry: React.FC = () => {
  const { merchant } = useMerchantModel();

  const [{ merchantPortalCashAppAfterpayTheme }] = useFeatureFlags();

  const registeredCountry =
    merchant?.companyInformation?.registeredCountry?.value ??
    merchant?.lead?.registeredCountry?.value;

  const navigate = useNavigate();

  useEffect(() => {
    if (!registeredCountry) return;
    if (!merchantPortalCashAppAfterpayTheme) return;

    const url = new URL(window.location.href);
    const currentCountry = url.searchParams.get("country");
    const newCountry = registeredCountry as CountryList;

    if (
      newCountry in CountryToCountryCodeMap &&
      currentCountry !== CountryToCountryCodeMap[newCountry]
    ) {
      url.searchParams.set("country", CountryToCountryCodeMap[newCountry]);
      const path = url.toString().split("app")[1];

      if (path) {
        navigate(path, { replace: true });
      }
    }
  }, [registeredCountry, navigate]);

  return null;
};
